import { BaseItemStore } from "../core/BaseStore";
import type PlansTemplateModel from "./PlansTemplateModel";

export default class PlansTemplateStore extends BaseItemStore<PlansTemplateModel> {
  byEditHash(editHash: string): PlansTemplateModel | undefined {
    return this.all.find((t) => t.data.editHash === editHash);
  }
}
